export default __webpack_public_path__ + "static/media/juridico.8a90071f.svg";